<template>
  <v-app id="login" class="grey lighten-3">
    <v-container fill-height fluid>
      <v-row justify="center">
        <v-col cols="lg-6 md-6 sm-6 xs-12">
          <v-sheet class="pa-6">
            <v-container>
              <v-row>
                <v-col>
                  <div class="d-flex justify-center">
                    <v-img src="../assets/logo-wocodea.png" max-width="220px" alt="Wocodea Logo"></v-img>
                  </div>

                  <v-divider class="my-5"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h1 class="text-center display-6">Firmenkunden Login</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-alert v-model="alert" type="error" width="100%" class="mx-3" color="primary" dismissible>Zugang nicht gestattet.</v-alert>
              </v-row>
              <v-row>
                <v-col>
                  <v-form @submit.prevent="login">
                    <span class="body-2 font-weight-bold">Email</span>
                    <v-text-field
                      v-model="email"
                      dense
                      outlined
                      placeholder="email@address.com"
                      color="grey lighten-3"
                      :rules="[rules.required, rules.email]"
                    ></v-text-field>

                    <span class="body-2 font-weight-bold">Password</span>
                    <v-text-field
                      v-model="password"
                      dense
                      outlined
                      color="grey lighten-3"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show ? 'text' : 'password'"
                      name="password"
                      value=""
                      @click:append="show = !show"
                    ></v-text-field>

                    <v-btn depressed color="primary" width="100%" type="submit">Login</v-btn>

                    <v-divider class="my-5"></v-divider>
                    <div class="d-flex justify-center">
                      <router-link :to="{ name: 'reset_password' }" class="body-2 grey--text text--darken-4">Passwort vergessen</router-link>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
// import axios from 'axios'
// import store from '../store'

export default {
  data: () => ({
    show: false,
    email: "",
    password: "",
    rules: {
      required: (value) => !!value || "Pflichtfeld.",
      min: (v) => v.length >= 4 || "Min. 6 Zeichen",
      email: (v) => /.+@.+\..+/.test(v) || "Bitte gültige Email-Adresse eingeben",
    },
    alert: false,
  }),
  methods: {
    async login() {
      const formData = new FormData();
      formData.append("client_id", process.env.VUE_APP_CLIENT_ID);
      formData.append("client_secret", process.env.VUE_APP_CLIENT_SECRET);
      formData.append("grant_type", "password");
      formData.append("username", this.email);
      formData.append("password", this.password);
      formData.append("scope", "");

      this.$store
        .dispatch("auth_request", formData)
        .then(() => {
          if(localStorage.getItem('user-role')==='marketing-user') {
            this.$router.push({name: "marketing"});
          } else {
            this.$router.push({name: "dashboard"});
          }
        })
        .catch(() => {
          this.alert = true;
        });
    },
  },
};
</script>
